import httpClient from '../httpClient';
import {
  AuthBody,
  EmailOrPhoneRequest,
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  ResendVerificationMailRequest,
} from '../../models/AuthBody';
import publicHttpClient from 'api/publicHttpClient';
import { User } from 'models/User';

const authPath = (routePath: TemplateStringsArray) => `auth/${routePath}`;

function register(userData: RegisterRequest) {
  return httpClient.post<AuthBody>(authPath`signup`, userData);
}

function login(userData: LoginRequest) {
  return httpClient.post<LoginResponse>(authPath`login`, userData);
}

function validateOtpt(userData: { otpToken: string; userId: string }) {
  return httpClient.post<AuthBody>(authPath`validate-otpt`, userData);
}

function forgotPassword(data: EmailOrPhoneRequest) {
  return httpClient.post<AuthBody>(authPath`forgot-password`, data);
}

function resetPassword(token: string, password: string) {
  return httpClient.post<AuthBody>(`auth/${token}/reset-password`, {
    password,
  });
}

const refreshToken = (refreshToken: string) => {
  return publicHttpClient.post(`auth/refresh-token`, { refreshToken });
};

function verifyEmail(emailToken: string, leadId?: string) {
  return publicHttpClient.get<AuthBody & { ndaUrl?: string }>(
    `auth/verify-email/${emailToken}`,
    { params: { leadId } },
  );
}

function getPrefilingValues(token: string) {
  return publicHttpClient.get<User>(`auth/external-user/${token}`);
}

function resendVerificationMail(data?: ResendVerificationMailRequest) {
  return httpClient.post<User>('auth/resend-verification-email', data);
}

function unsubscribeMail(token: string) {
  return publicHttpClient.get(`auth/email-unsubscribe/${token}`);
}

function loginWithMagicLink(token: string) {
  return publicHttpClient.get<AuthBody & { redirectPath: string }>(
    `auth/magic-link/${token}`,
  );
}

export default {
  validateOtpt,
  register,
  login,
  refreshToken,
  verifyEmail,
  forgotPassword,
  resetPassword,
  getPrefilingValues,
  resendVerificationMail,
  unsubscribeMail,
  loginWithMagicLink,
};
